import { Button, ButtonRow, Card, FormGroup, FormParagraph, FormSection } from '@ksyos/design-system';
import type { IStepProps } from '../NewGhcRequest';
import { AssetDropzoneWithThumbnails } from '../../../elements/organisms/assetDropzoneWithThumbnails/AssetDropzoneWithThumbnails';

export function Step5(props: IStepProps) {
    return (
        <>
            <Card.Header title=" Controleer je vraag en gegevens" />
            <Card.Body>
                <FormSection>
                    <FormGroup label="Telefoonnummer">
                        <FormParagraph>{props.request.customControlData.phoneNumber}</FormParagraph>
                    </FormGroup>
                    {props.request.customControlData.email && (
                        <FormGroup label="E-mailadres">
                            <FormParagraph>{props.request.customControlData.email}</FormParagraph>
                        </FormGroup>
                    )}
                    <FormGroup label="Wat zijn je klachten?">
                        <FormParagraph>{props.request.customControlData.complaints}</FormParagraph>
                    </FormGroup>
                    <FormGroup label="Waar voel je de klachten precies?">
                        <FormParagraph>{props.request.customControlData.complaintsLocation}</FormParagraph>
                    </FormGroup>

                    {props.request.customControlData.files.length > 0 && (
                        <>
                            <FormGroup label="Toegevoegde bestanden">
                                <AssetDropzoneWithThumbnails
                                    files={props.request.customControlData.files}
                                    onlyThumbnails
                                />
                            </FormGroup>
                        </>
                    )}

                    <FormGroup label="Hoeveel last heb je van de klachten?">
                        <FormParagraph>{props.request.customControlData.complaintsSeverity}</FormParagraph>
                    </FormGroup>
                    <FormGroup label="Hoelang heb je last van de klachten?">
                        <FormParagraph>{props.request.customControlData.complaintsDuration}</FormParagraph>
                    </FormGroup>
                    <FormGroup label="Zijn er bijkomende klachten of symptomen?">
                        <FormParagraph>
                            {props.request.customControlData.areThereAdditionalComplaintsOrSymptons}
                        </FormParagraph>
                    </FormGroup>
                    {props.request.customControlData.areThereAdditionalComplaintsOrSymptons === 'Ja' && (
                        <FormGroup label="Welke zijn dit?">
                            <FormParagraph>
                                {props.request.customControlData.areThereAdditionalComplaintsOrSymptonsRemark}
                            </FormParagraph>
                        </FormGroup>
                    )}
                    <FormGroup label="Heb je koorts?">
                        <FormParagraph>{props.request.customControlData.doYouHaveFever}</FormParagraph>
                    </FormGroup>
                    {props.request.customControlData.doYouHaveFever === 'Ja' && (
                        <FormGroup label="Hoe heb je dit gemeten?">
                            <FormParagraph>{props.request.customControlData.doYouHaveFeverRemark}</FormParagraph>
                        </FormGroup>
                    )}
                    <FormGroup label="Ben je wel eens in het ziekenhuis opgenomen?">
                        <FormParagraph>{props.request.customControlData.haveYouEverBeenHospitalized}</FormParagraph>
                    </FormGroup>
                    {props.request.customControlData.haveYouEverBeenHospitalized === 'Ja' && (
                        <FormGroup label="Waarvoor?">
                            <FormParagraph>
                                {props.request.customControlData.haveYouEverBeenHospitalizedRemark}
                            </FormParagraph>
                        </FormGroup>
                    )}

                    {props.request.customControlData.areYouBeingTreated && (
                        <>
                            <FormGroup label="Ben je onder behandeling door specialist of huisarts?">
                                <FormParagraph>{props.request.customControlData.areYouBeingTreated}</FormParagraph>
                            </FormGroup>
                            {props.request.customControlData.areYouBeingTreated === 'Ja' && (
                                <FormGroup label="Waarvoor?">
                                    <FormParagraph>
                                        {props.request.customControlData.areYouBeingTreatedRemark}
                                    </FormParagraph>
                                </FormGroup>
                            )}
                        </>
                    )}

                    {props.request.customControlData.areYouOnMedication && (
                        <>
                            <FormGroup label="Gebruik je medicijnen, pijnstillers of de pil?">
                                <FormParagraph>{props.request.customControlData.areYouOnMedication}</FormParagraph>
                            </FormGroup>
                            {props.request.customControlData.areYouOnMedication === 'Ja' && (
                                <FormGroup label="Welke en hoeveel?">
                                    <FormParagraph>
                                        {props.request.customControlData.areYouOnMedicationRemark}
                                    </FormParagraph>
                                </FormGroup>
                            )}
                        </>
                    )}

                    {props.request.customControlData.practitionerName && (
                        <FormGroup label="Naam van je huisarts">
                            <FormParagraph>{props.request.customControlData.practitionerName}</FormParagraph>
                        </FormGroup>
                    )}
                    {props.request.customControlData.organizationName && (
                        <FormGroup label="Praktijknaam van je huisarts">
                            <FormParagraph>{props.request.customControlData.organizationName}</FormParagraph>
                        </FormGroup>
                    )}
                </FormSection>
                <FormSection isBorderless>
                    <ButtonRow justify="center">
                        {props.submit && (
                            <Button
                                isDisabled={props.isSubmitting}
                                onClick={props.submit}
                                type="button"
                                variant="solid"
                            >
                                {!props.isSubmitting ? 'Verzend vraag' : 'Bezig met verwerken…'}
                            </Button>
                        )}
                    </ButtonRow>
                </FormSection>
            </Card.Body>
        </>
    );
}
